import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { ExpenseAdvanceDTO, ExpenseAdvanceRequest } from '../interfaces/expense.interface';

interface PagedResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export const ExpenseAdvanceService = {
    request: async (req: Omit<ExpenseAdvanceRequest, 'institutionId'>): Promise<ExpenseAdvanceDTO> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(
            ENDPOINTS.EXPENSE_ADVANCE.REQUEST,
            { ...req, institutionId },
            { headers: AuthService.getAuthHeader() },
        );
        return response.data;
    },

    getById: async (id: string): Promise<ExpenseAdvanceDTO> => {
        const response = await axios.get(ENDPOINTS.EXPENSE_ADVANCE.GET_BY_ID(id), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    listMine: async (page = 0, size = 50): Promise<PagedResponse<ExpenseAdvanceDTO>> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.EXPENSE_ADVANCE.LIST_MINE(institutionId), {
            params: { page, size },
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    listPendingApproval: async (page = 0, size = 50): Promise<PagedResponse<ExpenseAdvanceDTO>> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.EXPENSE_ADVANCE.PENDING_APPROVAL(institutionId), {
            params: { page, size },
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    approve: async (id: string): Promise<ExpenseAdvanceDTO> => {
        const response = await axios.post(ENDPOINTS.EXPENSE_ADVANCE.APPROVE(id), null, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    reject: async (id: string): Promise<ExpenseAdvanceDTO> => {
        const response = await axios.post(ENDPOINTS.EXPENSE_ADVANCE.REJECT(id), null, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    pay: async (id: string, cashOrBankAccountId: string): Promise<ExpenseAdvanceDTO> => {
        const response = await axios.post(
            ENDPOINTS.EXPENSE_ADVANCE.PAY(id),
            { cashOrBankAccountId },
            { headers: AuthService.getAuthHeader() },
        );
        return response.data;
    },
};
